module.exports = __webpack_public_path__ + "static/media/footer.dc6e5750.png";